// src/common/components/cartModal/components/bonusSpendSelector/BonusSpendSelector.tsx
import React from "react";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./BonusSpendSelector.module.scss";

interface BonusSpendSelectorProps {
  balance: number;
  maxWriteOff: number;
  value: number;
  onChange: (value: number) => void;
}

export default function BonusSpendSelector({
  balance,
  maxWriteOff,
  value,
  onChange,
}: BonusSpendSelectorProps) {
  const { theme } = useTheme();

 const maxAllowed = Math.floor(Math.min(maxWriteOff, balance))

  const setMax = () => {
    onChange(maxAllowed);
  };

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Math.floor(Number(e.target.value)));
  };

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: theme.card,
        borderColor: theme.border,
      }}
    >
      <div className={styles.header}>
        <span className={styles.title} style={{ color: theme.text }}>
          Списать бонусы
        </span>
        <button className={styles.maxButton} onClick={setMax}>
          <span
            className={styles.maxButtonText}
            style={{ color: theme.onPrimary }}
          >
            Списать максимум
          </span>
        </button>
      </div>

      <div className={styles.sliderContainer}>
        <input
          type="range"
          min="0"
          max={maxAllowed}
          value={value}
          onChange={handleSliderChange}
          step="1"
          className={styles.slider}
          style={{
            background: `linear-gradient(to right, ${theme.primary} 0%, ${theme.primary} ${maxAllowed > 0 ? (value / maxAllowed) * 100 : 0}%, ${theme.border} ${maxAllowed > 0 ? (value / maxAllowed) * 100 : 0}%, ${theme.border} 100%)`,
          }}
        />
        <div className={styles.valueRow}>
          <span className={styles.valueText} style={{ color: theme.text }}>
            Списать: {value} ₽
          </span>
          <span
            className={styles.maxValue}
            style={{ color: theme.textSecondary }}
          >
            Макс: {maxAllowed} ₽
          </span>
        </div>
      </div>
    </div>
  );
}
